/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react-native/no-inline-styles */
import React, {useEffect, useState} from 'react';
import theme from '../../../../../global/styles/theme';
import TextDefault from '../../../../../components/TextDefault';
import {TabView, SceneMap, TabBar} from 'react-native-tab-view';
import {StatusBarContainer} from '../../../../../components/StatusBar';
import * as S from './styles';
import {RootState} from '../../../../../store';
import {useDispatch, useSelector} from 'react-redux';
import * as Clipboard from 'expo-clipboard';
import {
  Dimensions,
  FlatList,
  Text,
  useWindowDimensions,
  View,
} from 'react-native';
import {priceUnmask, toPrice} from '../../../../../utils/functions';
import Button from '../../../../../components/Button';
import DefaultModal from '../../../../../components/DefaultModal';
import Input from '../../../../../components/Input';
import {useForm} from 'react-hook-form';
import {schemaFinancial} from '../../../../../utils/schema';
import {yupResolver} from '@hookform/resolvers/yup';
import {useIsFocused, useNavigation} from '@react-navigation/native';
import {TouchableOpacity} from 'react-native';
import {toastConfig} from '../../../../../components/Toast';
import {
  createTransactions,
  getExtracts,
} from '../../../../../services/extracts';
import Toast from 'react-native-toast-message';
import {lightFormat} from 'date-fns';
import {refreshToken} from '../../../../../services/auth';
import {updateUser} from '../../../../../store/modules/user/actions';

const financialResolver = {
  resolver: yupResolver(schemaFinancial),
};

export default function ExtractScreen() {
  const appTheme = useSelector((state: RootState) => state.config.appTheme);
  const navigation: any = useNavigation();

  const {
    control,
    handleSubmit,
    reset,
    formState: {errors},
  } = useForm(financialResolver);
  const userInfo = useSelector((state: RootState) => state?.user?.user);
  const layout = useWindowDimensions();
  const focusScreen = useIsFocused();
  const dispatch = useDispatch();

  const initialRoutes = [
    {key: 'deposit', title: 'Depósitos'},
    {key: 'withdraw', title: 'Saques'},
  ];

  const [pageDeposit, setPageDeposit] = useState(1);
  const [qtdPagesDeposit, setQtdPagesDeposit] = useState(1);
  const [listDeposit, setListDeposit] = useState<Array<any>>([]);
  const [pageWithdraw, setPageWithdraw] = useState(1);
  const [qtdPagesWithdraw, setQtdPagesWithdraw] = useState(1);
  const [listWithdraw, setListWithdraw] = useState<Array<any>>([]);

  const [modalSaque, setModalSaque] = useState(false);
  const [stepModalSaque, setStepModalSaque] = useState(1);
  const [infoTransaction, setInfoTransaction] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [index, setIndex] = useState(0);
  const [routes] = useState(initialRoutes);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      getListExtracts();
    }, 500);

    return () => clearTimeout(timeoutId);
  }, [pageDeposit, pageWithdraw, index]);

  useEffect(() => {
    if (focusScreen) {
      getNewToken();
    }
  }, [focusScreen]);

  function onEndReachedDeposit() {
    if (pageDeposit < qtdPagesDeposit) {
      setPageDeposit(pageDeposit + 1);
    }
  }

  function onEndReachedWithdraw() {
    if (pageWithdraw < qtdPagesWithdraw) {
      setPageWithdraw(pageWithdraw + 1);
    }
  }

  const getListExtracts = async () => {
    try {
      const response = await getExtracts(
        !index ? 'deposit' : 'withdraw',
        undefined,
        userInfo?.user?.id,
        '',
        !index ? pageDeposit : pageWithdraw,
        userInfo?.token,
      );
      if (!index) {
        setQtdPagesDeposit(response?.result?.qtdPages || 1);
        setListDeposit(response?.result?.list || []);
      } else {
        setQtdPagesWithdraw(response?.result?.qtdPages || 1);
        setListWithdraw(response?.result?.list || []);
      }
    } catch (error) {
      console.log('error', error);
    }
  };

  const getNewToken = async () => {
    await refreshToken(
      {refresh: userInfo?.tokenRefresh, type: 'users'},
      userInfo?.token,
    )
      .then(response => {
        const newToken = response?.data?.result?.token;
        dispatch(
          // @ts-ignore
          updateUser({
            ...userInfo,
            token: newToken || userInfo?.token,
            user: response?.data?.result?.user,
          }),
        );
      })
      .catch(error => {
        console.log('error', error);
      });
  };

  const handlePress = async (data: any) => {
    setIsLoading(true);
    const unMaskValue = priceUnmask(data.value);
    const formatBody: any = {
      value: unMaskValue,
      type: !index ? 'deposit' : 'withdraw',
      idUser: userInfo?.user?.id,
    };
    await createTransactions(formatBody, userInfo?.token)
      .then(async response => {
        setIsLoading(false);
        if (!index) {
          setStepModalSaque(2);
          setInfoTransaction(response?.data?.result?.extract);
        } else {
          setModalSaque(false);
          getNewToken();
        }
        reset();
        getListExtracts();
        Toast.show({
          type: 'success',
          text1: response?.data?.message || 'Dados atualizados!',
        });
      })
      .catch(error => {
        setIsLoading(false);
        Toast.show({
          type: 'error',
          text1:
            error?.response?.data?.message ||
            'Ocorreu um erro, tente novamente mais tarde!',
        });
      });
  };

  const deposit = () => {
    return (
      <FlatList
        data={listDeposit}
        renderItem={renderItemExtract}
        keyExtractor={item => String(item.id)}
        style={{width: '100%'}}
        contentContainerStyle={{paddingBottom: 60, paddingTop: 20}}
        indicatorStyle={appTheme === 'dark' ? 'white' : 'black'}
        onEndReached={onEndReachedDeposit}
        onEndReachedThreshold={0.3}
      />
    );
  };

  const withdraw = () => {
    return (
      <FlatList
        data={listWithdraw}
        renderItem={renderItemExtract}
        keyExtractor={item => String(item.id)}
        style={{width: '100%'}}
        contentContainerStyle={{paddingBottom: 60, paddingTop: 20}}
        indicatorStyle={appTheme === 'dark' ? 'white' : 'black'}
        onEndReached={onEndReachedWithdraw}
        onEndReachedThreshold={0.3}
      />
    );
  };

  const renderScene = SceneMap({
    deposit,
    withdraw,
  });

  const renderTabBar = (propsTabView: any) => {
    return (
      <TabBar
        {...propsTabView}
        renderTabBarItem={renderTabBarItem}
        indicatorStyle={{
          backgroundColor: 'white',
          elevation: 0,
          height: 3,
        }}
        style={{
          alignSelf: 'center',
          backgroundColor: theme.colors(appTheme).black[500],
          elevation: 0,
          shadowOffset: {
            height: 0,
            width: 0,
          },
          shadowColor: 'transparent',
          shadowRadius: 0,
          shadowOpacity: 1,
          width: '100%',
        }}
        contentContainerStyle={{
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%',
        }}
        renderIndicator={() => null}
      />
    );
  };

  const renderTabBarItem = (propsTabBar: any) => {
    const {title} = propsTabBar.route;
    const focus = title === initialRoutes[index].title;

    return (
      // @ts-ignore
      <TouchableOpacity
        {...propsTabBar}
        style={{
          alignItems: 'center',
          justifyContent: 'center',
          paddingTop: 10,
          width: layout.width / 2,
        }}>
        <TextDefault
          text={title}
          color={
            focus
              ? theme.colors(appTheme).main[700]
              : theme.colors(appTheme).white
          }
          fontSize={14}
        />
        <S.BottomMarked
          style={{
            backgroundColor: focus
              ? theme.colors(appTheme).main[700]
              : 'transparent',
          }}
        />
      </TouchableOpacity>
    );
  };

  const onChangeIndex = (indexActual: number) => {
    setIndex(indexActual);
  };

  const renderItemExtract = ({item}: any) => {
    return (
      <S.Item
        onPress={() => {
          setModalSaque(true);
          setStepModalSaque(2);
          setInfoTransaction(item);
        }}
        disabled={
          (item.type === 'deposit' && item.status !== 'pending') ||
          (item.type === 'withdraw' && item.status !== 'finish')
        }>
        <S.Row>
          <S.IconImageMaterialIcons
            color={theme.colors(appTheme).white}
            size={32}
            name={item.status === 'pending' ? 'manage-history' : 'history'}
          />
          <S.Column>
            <TextDefault
              fontSize={14}
              color={theme.colors(appTheme).white}
              text={
                item.status === 'finish' || item.status === 'canceled'
                  ? lightFormat(new Date(item.updated_at), 'dd/MM/yyyy')
                  : 'Processando...'
              }
              fontFamily={theme.fonts.family.opensans.semi_bold}
            />
            <TextDefault
              fontSize={10}
              color={theme.colors(appTheme).white}
              text={
                item.status === 'finish' || item.status === 'canceled'
                  ? lightFormat(new Date(item.updated_at), 'HH:mm')
                  : 'Processando...'
              }
              marginTop={5}
              fontFamily={theme.fonts.family.opensans.semi_bold}
            />
          </S.Column>
        </S.Row>
        <S.Column style={{alignItems: 'flex-end'}}>
          <TextDefault
            fontSize={14}
            color={
              item.value >= 0
                ? theme.colors(appTheme).green[900]
                : theme.colors(appTheme).red[400]
            }
            text={
              item.value >= 0
                ? `R$ ${toPrice(item.value, 2)}`
                : `R$ ${toPrice(item.value, 2)}`
            }
            fontFamily={theme.fonts.family.opensans.semi_bold}
          />
          <TextDefault
            fontSize={10}
            color={
              item.status === 'pending'
                ? theme.colors(appTheme).main[800]
                : item.status === 'canceled'
                ? theme.colors(appTheme).red[600]
                : theme.colors(appTheme).blue[300]
            }
            text={
              item.status === 'pending'
                ? 'Pendente'
                : item.status === 'canceled'
                ? 'Cancelado'
                : 'Finalizado'
            }
            marginTop={5}
            fontFamily={theme.fonts.family.opensans.semi_bold}
          />
        </S.Column>
      </S.Item>
    );
  };

  return (
    <>
      <StatusBarContainer />
      <S.Container appTheme={appTheme}>
        <S.ContainerArea appTheme={appTheme}>
          <S.HeaderList>
            <S.ButtonGoBack onPress={() => navigation.goBack()}>
              <S.IconImage
                color={theme.colors(appTheme).white}
                size={26}
                name="arrow-left"
              />
            </S.ButtonGoBack>
            <TextDefault
              fontSize={18}
              color={theme.colors(appTheme).white}
              text="Financeiro"
              fontFamily={theme.fonts.family.opensans.semi_bold}
              textAlign="center"
            />
            <Button
              title={!index ? 'DEPOSITAR' : 'SACAR'}
              onPress={() => setModalSaque(true)}
              fontFamily={theme.fonts.family.opensans.bold}
              width={100}
              height={40}
            />
          </S.HeaderList>
          <TextDefault
            fontSize={18}
            color={theme.colors(appTheme).white}
            text={`Meu saldo: R$ ${toPrice(userInfo?.user?.wallet || 0, 2)}`}
            fontFamily={theme.fonts.family.opensans.semi_bold}
            style={{width: '90%', alignSelf: 'center', marginBottom: 20}}
          />
          <TabView
            navigationState={{index, routes}}
            renderScene={renderScene}
            renderTabBar={renderTabBar}
            onIndexChange={onChangeIndex}
            initialLayout={{width: layout.width}}
            style={{
              // height: 50,
              width: '100%',
            }}
          />
        </S.ContainerArea>
        <DefaultModal
          modalVisible={modalSaque}
          setModalVisible={setModalSaque}
          onClose={() => {
            reset();
            setInfoTransaction(null);
            setStepModalSaque(1);
          }}>
          {stepModalSaque === 1 ? (
            <S.ContainerModal appTheme={appTheme}>
              <View
                style={{
                  position: 'absolute',
                  left: 0,
                  top: -120,
                  width: Dimensions.get('window').width / 1.1,
                  zIndex: 1,
                }}>
                <Toast config={toastConfig} />
              </View>
              <TextDefault
                fontSize={20}
                color={theme.colors(appTheme).white}
                marginBottom={10}
                text={!index ? 'Operação de depósito' : 'Operação de saque'}
                fontFamily={theme.fonts.family.opensans.semi_bold}
              />
              <Input
                title={
                  !index ? 'Quanto deseja depositar?' : 'Quanto deseja sacar?'
                }
                errors={errors}
                placeholder="Ex.: R$ 10,00"
                control={control}
                name="value"
                marginTop={10}
                width="100%"
                mask="money"
                hideBorder
                keyboardType="phone-pad"
              />
              <Button
                title={!index ? 'EFETUAR DEPÓSITO' : 'EFETUAR SAQUE'}
                onPress={handleSubmit(handlePress)}
                fontFamily={theme.fonts.family.opensans.bold}
                marginTop={20}
                isLoading={isLoading}
              />
            </S.ContainerModal>
          ) : (
            <S.ContainerModal appTheme={appTheme}>
              <View
                style={{
                  position: 'absolute',
                  left: 0,
                  top: -120,
                  width: Dimensions.get('window').width / 1.1,
                  zIndex: 1,
                }}>
                <Toast config={toastConfig} />
              </View>
              <TextDefault
                fontSize={20}
                color={theme.colors(appTheme).white}
                marginBottom={10}
                text={
                  !index ? 'QR CODE para pagamento' : 'Comprovante do saque'
                }
                fontFamily={theme.fonts.family.opensans.semi_bold}
              />
              {!index ? (
                <S.Column>
                  <S.ImageQrcode
                    resizeMode="contain"
                    source={{uri: infoTransaction?.qrcode}}
                  />
                  <S.Row>
                    <TouchableOpacity
                      onPress={async () => {
                        Clipboard.setStringAsync(
                          infoTransaction?.copy_and_paste || '',
                        );
                        Toast.show({
                          type: 'success',
                          text1: 'Copiado para área de transferência',
                        });
                      }}>
                      <S.IconImage
                        color={theme.colors(appTheme).white}
                        size={26}
                        name="copy"
                      />
                    </TouchableOpacity>
                    <Text
                      style={{
                        color: theme.colors(appTheme).white,
                        fontSize: 10,
                        flex: 1,
                      }}>
                      {infoTransaction?.copy_and_paste}
                    </Text>
                  </S.Row>
                </S.Column>
              ) : (
                <S.ImageProof
                  source={{uri: infoTransaction?.proof_of_payment}}
                  resizeMode="contain"
                />
              )}
              <Button
                title={!index ? 'EFETUEI O PAGAMENTO' : 'ENTENDI'}
                onPress={() => {
                  setInfoTransaction(null);
                  setStepModalSaque(1);
                  setModalSaque(false);
                }}
                fontFamily={theme.fonts.family.opensans.bold}
                marginTop={20}
                isLoading={isLoading}
              />
            </S.ContainerModal>
          )}
        </DefaultModal>
        {modalSaque ? null : <Toast config={toastConfig} />}
      </S.Container>
    </>
  );
}
